import React from 'react';
import { FaXmark } from 'react-icons/fa6';

type SearchInputProps = {
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  className?: string;
};

const SearchBot: React.FC<SearchInputProps> = ({ value, placeholder, onChange, className }) => {
  return (
    <div className={`position-relative ${className || ''}`}>
      <input
        type='text'
        className='form-control pe-5'
        value={value}
        placeholder={placeholder || 'Search...'}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <span
          className='position-absolute end-0 top-50 translate-middle-y me-3 cursor-pointer text-muted'
          onClick={() => onChange('')}
          style={{ zIndex: 2 }}
        >
          <FaXmark />
        </span>
      )}
    </div>
  );
};

export default SearchBot;
